const state = {
  drawerMenu: false,
  dialogAlterarSenha: false,
  dialogAutorizacao: false,
  dialogSilenciarProduto: false,
  dialogProdutosSilenciados: false,
  empresa: {
    nome: "Systock",
    logo: require("../../assets/systock.png"),
    logo_header: require("../../assets/logo_header.png")
  },
  usuario: {
    nome: localStorage.getItem("nome"),
    cargo: "Comprador",
    setor: localStorage.getItem("setor"),
    foto: require("../../assets/user.png")
  }
};

const getters = {};

const mutations = {
  setDrawerMenu(state, payload) {
    state.drawerMenu = payload;
  },
  setDialogAlterarSenha(state, payload) {
    state.dialogAlterarSenha = payload;
  },
  setDialogSilenciarProduto(state, payload) {
    state.dialogSilenciarProduto = payload;
  },
  setDialogProdutosSilenciados(state, payload) {
    state.dialogProdutosSilenciados = payload;
  },
  setDialogAutorizacao(state, payload) {
    state.dialogAutorizacao = payload;
  },
  setUsuario(state, payload) {
    state.usuario = payload;
  }
};

const actions = {};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};
